import searchBoxTemplate from './searchBox.html';

const searchBox = {

    bindings: {
        placeholderText: '@',
        onSearchChanged: '&',
        onSearchCleared: '&',
        searchText: '=?'
    },

    template: searchBoxTemplate,

    controller: function () {

        this.searchChanged = function () {
            this.onSearchChanged({ text: this.searchText });
        }

        this.clearSearchBox = function () {
            console.log('cleared files-insearch');
            this.searchText = '';
            this.onSearchCleared();
        }
    }

}

export default searchBox;


/** WEBPACK FOOTER **
 ** ./src/app/directives/searchBox/searchBox.js
 **/